var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8931 6.07205L14.2238 0.572971C14.107 0.39684 13.9484 0.252347 13.7622 0.152374C13.576 0.0524015 13.368 5.44592e-05 13.1566 0H1.28577C0.944763 0 0.617722 0.135465 0.376593 0.376593C0.135465 0.617722 0 0.944763 0 1.28577V11.5719C0 11.9129 0.135465 12.24 0.376593 12.4811C0.617722 12.7222 0.944763 12.8577 1.28577 12.8577H13.1566C13.3678 12.8573 13.5757 12.8049 13.7618 12.7051C13.9479 12.6053 14.1066 12.4612 14.2238 12.2855L17.8907 6.78565C17.9615 6.68025 17.9996 6.55622 18 6.42922C18.0004 6.30222 17.9632 6.17793 17.8931 6.07205Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualLabel);
export default __webpack_public_path__ + "static/media/manual_label.a5b417044410c8d3e75356ceaeaadbde.svg";
export { ForwardRef as ReactComponent };